import { EFavoritesActionTypes } from './types';
import { IFavoritesState } from '../../types/favorites';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateUserFavorites = actionGenerator<
  EFavoritesActionTypes.UpdateUserFavorites,
  IFavoritesState['favoriteItems']
>(EFavoritesActionTypes.UpdateUserFavorites);
